/*
 *
 * EditCompanyPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 02-Apr-2025
 */

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  cancel: (
    <PortalMessage
      id='t.app.cancel'
      defaultMessage='Annulla'
    />
  ),
  requiredError: (
    <PortalMessage
      id='t.app.error.requiredField'
      defaultMessage='Il campo è obbligatorio'
    />
  ),
  confirm: (
    <PortalMessage
      id='t.app.shopSelector.applySelection'
      defaultMessage='Applica selezione'
    />
  ),
  modalCustomName: (
    <PortalMessage
      id='t.app.costs.commissions.economic.conditions.title'
      defaultMessage='Condizioni economiche'
    />
  ),
  modalEditNameSubtitle: (
    <PortalMessage
      id='t.app.costs.economic.conditions.modal.subtitle'
      defaultMessage='Per visualizzare le condizioni economiche devi applicare una selezione.'
    />
  ),
  shopNameLabel: (
    <PortalMessage
      id='t.app.shopName'
      defaultMessage='Punto vendita'
    />
  ),
  selectShopNamePlaceholder: (
    <PortalMessage
      id='t.app.costs.economic.conditions.modal.shops.placeholder'
      defaultMessage='Seleziona punto vendita'
    />
  ),
  paymentContractLabel: (
    <PortalMessage
      id='t.app.costs.economic.conditions.modal.paymentContract'
      defaultMessage='Payment contract:'
    />
  ),
  shopTypeLabel: (
    <PortalMessage
      id='t.app.costs.economic.conditions.modal.shopType'
      defaultMessage='Tipologia:'
    />
  ),
  offerCodeLabel: (
    <PortalMessage
      id='t.app.costs.economic.conditions.modal.offerCode'
      defaultMessage='Offerta'
    />
  ),
  selectOfferCodePlaceholder: (
    <PortalMessage
      id='t.app.costs.economic.conditions.modal.selectOfferCodePlaceholder'
      defaultMessage='Seleziona offerta'
    />
  ),
  abiCodeLabel: (
    <PortalMessage
      id='t.app.costs.economic.conditions.modal.abiCode'
      defaultMessage='Codice ABI'
    />
  ),
  selectAbiPlaceholder: (
    <PortalMessage
      id='t.app.costs.economic.conditions.modal.selectAbiPlaceholder'
      defaultMessage='Seleziona codice ABI'
    />
  ),
  abiOptions: (
    <PortalMessage
      id='t.app.costs.economic.conditions.modal.abiOptions'
      defaultMessage='codice ABI'
    />
  )
}

export default formattedMessage
